import { render, staticRenderFns } from "./ReverseLanguageNotification.vue?vue&type=template&id=143623f6"
import script from "./ReverseLanguageNotification.vue?vue&type=script&lang=js"
export * from "./ReverseLanguageNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports